import type {
  ChangePasswordBody,
  LoginBody,
  LoginResponse,
  MeResponse,
  UpdateUserBody,
  User,
} from '@tasks/contracts';

import { apiRequest, apiRequestVoid } from './client';

export function fetchMe(signal?: AbortSignal): Promise<MeResponse> {
  return apiRequest<MeResponse>('/me', { signal });
}

export function login(body: LoginBody): Promise<LoginResponse> {
  return apiRequest<LoginResponse>('/auth/login', { method: 'POST', body });
}

export function logout(): Promise<void> {
  return apiRequestVoid('/auth/logout', { method: 'POST' });
}

export function changePassword(body: ChangePasswordBody): Promise<void> {
  return apiRequestVoid('/auth/change-password', { method: 'POST', body });
}

/** Профиль: имя и аватар (UC-AUTH-07). */
export function updateMyProfile(body: UpdateUserBody): Promise<{ user: User }> {
  return apiRequest<{ user: User }>('/me', { method: 'PATCH', body });
}

export function uploadMyAvatar(file: File): Promise<{ user: User }> {
  const formData = new FormData();
  formData.append('file', file);
  return apiRequest<{ user: User }>('/me/avatar', { method: 'POST', formData });
}

export function removeMyAvatar(): Promise<{ user: User }> {
  return apiRequest<{ user: User }>('/me/avatar', { method: 'DELETE' });
}

export type { User };
